












































































































































































































































































import {
  defineComponent,
  useContext,
  useMeta,
  onMounted,
  ref,
  useRoute,
  onUnmounted,
  onUpdated,
} from '@nuxtjs/composition-api';
import NewsCard from '~/components/pages/Other/NewsCard.vue';
import ProductKeywords from '~/components/pages/Product/ProductKeywords.vue';
import TopArticleSection from '~/components/pages/Top/TopArticleSection.vue';
import TopBadgeIcons from '~/components/pages/Top/TopBadgeIcons.vue';
import TopBottomBanner from '~/components/pages/Top/TopBottomBanner.vue';
import TopCarouselSlider from '~/components/pages/Top/TopCarouselSlider.vue';
import TopCustomerSatisfaction from '~/components/pages/Top/TopCustomerSatisfaction.vue';
import TopDistributionCard from '~/components/pages/Top/TopDistributionCard.vue';
import TopGourmetSnackSection from '~/components/pages/Top/TopGourmetSnackSection.vue';
import TopHorizontalItems from '~/components/pages/Top/TopHorizontalItems.vue';
import TopItemCard from '~/components/pages/Top/TopItemCard.vue';
import TopLocaleFeatureSection from '~/components/pages/Top/TopLocaleFeatureSection.vue';
import TopNewsSlider from '~/components/pages/Top/TopNewsSlider.vue';
import TopRankingSection from '~/components/pages/Top/TopRankingSection.vue';
import TopSaleBanner from '~/components/pages/Top/TopSaleBanner.vue';
import TopSceneAndKeywordSection from '~/components/pages/Top/TopSceneAndKeywordSection.vue';
import TopSection from '~/components/pages/Top/TopSection.vue';
import TopSingleItemSections from '~/components/pages/Top/TopSingleItemSections.vue';
import TopStaffReviewCard from '~/components/pages/Top/TopStaffReviewCard.vue';
import AppArchiveCard from '~/components/partials/App/AppArchiveCard.vue';
import AppContentGrid from '~/components/partials/App/AppContentGrid.vue';
import AppFreeArea from '~/components/partials/App/AppFreeArea.vue';
import AppLoader from '~/components/partials/App/AppLoader.vue';
import AppProducerCard from '~/components/partials/App/AppProducerCard.vue';
import GlobalHeaderMenu from '~/components/partials/Global/GlobalHeaderMenu.vue';
import LayoutDefault from '~/components/partials/Layout/LayoutDefault.vue';
import RecommendItemsHorizontal from '~/components/partials/SilverEgg/RecommendItemsHorizontal.vue';
import { useSilverEggApi } from '~/composables/silverEgg/useSilverEggApi';
import { useCriteoTag } from '~/composables/tag/useCriteoTag';
import { useTopParts } from '~/composables/top/useTopParts';
import { useEnotecaApp } from '~/composables/useEnotecaApp';
import { useFirstPurchasePromotion } from '~/composables/useFirstPurchasePromotion';
import { useKeepScroll } from '~/composables/useKeepScroll';
import { useLayoutProps } from '~/composables/useLayoutProps';
import { useStore } from '~/composables/useStore';
import {
  PRODUCT_CATEGORY_ID,
  PRODUCT_PARAM_QUERIES,
  REQUEST_NUM_TOP_RANKING_SP,
  REQUEST_NUM_TOP_RANKING_PC,
} from '~/constants';
import { url } from '~/utils';
import { sendGaEvent } from '~/utils/ga';
import { TopSilverEggItems, RankingTabIndex } from '~/types/common/silverEgg';
import { BooleanLike } from '~/enums';

export default defineComponent({
  components: {
    LayoutDefault,
    AppLoader,
    AppContentGrid,
    AppArchiveCard,
    AppProducerCard,
    ProductKeywords,
    TopHorizontalItems,
    TopCarouselSlider,
    TopNewsSlider,
    AppFreeArea,
    TopBadgeIcons,
    TopRankingSection,
    TopSection,
    TopSaleBanner,
    TopLocaleFeatureSection,
    TopStaffReviewCard,
    TopCustomerSatisfaction,
    TopGourmetSnackSection,
    TopItemCard,
    TopBottomBanner,
    TopSingleItemSections,
    TopArticleSection,
    TopSceneAndKeywordSection,
    NewsCard,
    GlobalHeaderMenu,
    RecommendItemsHorizontal,
    TopDistributionCard,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const { $device } = useContext();
    const { isEnotecaAppWebView } = useEnotecaApp();
    const parts = useTopParts();
    const criteoTag = useCriteoTag();
    const { hasPurchaseHistory } = useFirstPurchasePromotion();
    const { scrollToPreviousPosition, setPageData } = useKeepScroll();
    const authenticated = ref(store.state.auth.authenticated);
    const isOpenKeywordTags = ref<boolean>(
      store.getters['internals/keepScroll/detailsElements'](route.value.path, route.value.fullPath)?.[0]?.isOpen ??
        false
    );
    const activeLocaleTabIndex = ref<number>(
      store.getters['internals/keepScroll/tabs'](route.value.path, route.value.fullPath, 0)
    );
    const activeRankingTabIndex = ref<RankingTabIndex>(
      store.getters['internals/keepScroll/tabs'](route.value.path, route.value.fullPath, 1)
    );
    // シルバーエッグ用
    const { fetchTopPageItems, fetchRankingItems } = useSilverEggApi();
    const silverEggItems = ref<TopSilverEggItems>();
    const silverEggRankingItems: Array<TopSilverEggItems['ranking']> = Array(4).fill({});
    const requestRankingNum = $device.isMobile ? REQUEST_NUM_TOP_RANKING_SP : REQUEST_NUM_TOP_RANKING_PC;
    const activeRankingItems = ref<TopSilverEggItems['ranking']>();

    const setRankingActiveTabIndex = async (activeTabIndex: RankingTabIndex) => {
      activeRankingTabIndex.value = activeTabIndex;
      if (Object.keys(silverEggRankingItems[activeTabIndex]).length === 0) {
        silverEggRankingItems[activeTabIndex] = await fetchRankingItems(activeTabIndex, requestRankingNum);
      }
      activeRankingItems.value = silverEggRankingItems[activeTabIndex];
    };

    useLayoutProps(() => {
      return {
        layout: {
          header: 'always',
          headerMenu: 'never',
        },
        jsonld: [
          {
            type: 'SearchAction',
            data: {
              url: url('ITEM_LIST'),
              keywordQuery: PRODUCT_PARAM_QUERIES.WORD,
            },
          },
        ],
      };
    });

    onMounted(async () => {
      // rakuten計測用スクリプト
      if ($device.isMobile) {
        useMeta(() => ({
          script: [{ src: 'https://point.widget.rakuten.co.jp/openid/parts?checkout=c320x73a1v3' }],
        }));
      }
      // criteo計測用タグ
      criteoTag.setTopTag();

      // シルバーエッグのアイテムを取得する
      silverEggItems.value = await fetchTopPageItems(activeRankingTabIndex.value, requestRankingNum);
      silverEggRankingItems[activeRankingTabIndex.value] = silverEggItems.value.ranking;
      activeRankingItems.value = silverEggRankingItems[activeRankingTabIndex.value];

      if (!authenticated.value) return;
      try {
        await store.dispatch('modules/lottery/fetchLotteryApplications', {
          query: { is_applying: true },
        });
      } catch {
        // 何もしない
      }
    });

    onUpdated(() => {
      if (parts.value && silverEggItems.value) {
        scrollToPreviousPosition();
      }
    });

    onUnmounted(() => {
      setPageData({
        tabs: [activeLocaleTabIndex.value, activeRankingTabIndex.value], // 0:産地特集, 1:売れ筋ワインランキング
        detailsElements: [{ isOpen: isOpenKeywordTags.value }], // 0:キーワード
      });
    });

    return {
      parts,
      url,
      PRODUCT_PARAM_QUERIES,
      PRODUCT_CATEGORY_ID,
      BooleanLike,
      hasPurchaseHistory,
      authenticated,
      isEnotecaAppWebView,
      sendGaEvent,
      silverEggItems,
      activeRankingItems,
      isOpenKeywordTags,
      activeLocaleTabIndex,
      activeRankingTabIndex,
      setRankingActiveTabIndex,
    };
  },
  head: {},
});
